export const NO_HOST_CONNECTION_COMPONENT = "Entity doesn't have a host connections component.";
export const COMPONENT_DOESNT_EXIST = "Component doesn't exist.";
export const NO_SIZE = "Entity didn't have a size.";
export const NO_PRODUCT_REF = "Entity didn't have productRef.";
export const ENTITY_NULL = "Expected entity not defined";
export const CONNECTOR_DOESNT_EXISTS = "Connector doesnt exist";
export const UNIQUE_CONNECTION_COULD_NOT_BE_FOUND = "Unique connection could not be found";
export const CONNECTORS_EQUAL = "Connections are equal.";
export const NO_CONNECTION_KEY = "Connection key not found.";
export const NO_CONNECTION = "No connection.";
export const CHILD_IS_ORPHAN = "Child didn't have a parent..  =(";
export const CHILD_MISSING_PARENT = "Child lacks one or more parent. Not very responsible.";
export const CANT_CREATE_VIEWER_OBJECT = "A viewer object could not be created.";
export const CANT_CREATE_ENTITY = "Entity could not be created.";
export const NO_PRICE = "No price information found.";
export const NO_SNAP_ACTION = "No snap action could be created.";
export const INVALID_SNAP_ACTION = "Invalid snap action.";
export const WIDTH_NOT_SUPPORTED = "Width not supported.";
export const NO_VIEWER = "Unable to get IViewer.";
export const NO_PARENT = "No parent entity found";
export const NO_VIEWER_OBJECT = "No viewer object found on entity";
export const ENTITY_NOT_IN_CATALOG = "Entity not in catalog";
export const ENTITY_HAS_NO_META = "No meta on entity";
export const MISSING_BRACKET = "Adjustable shelf is missing bracket entity";
export const MISSING_ADJUSTABLE_PART = "Entity is missing adjustable assembly part";
export const MISSING_OCCUPIED_HOLES = "Entity is missing holesOccupied data";
export const CORE_DOESNT_EXIST = "Instance of core doesn't exist.";
export const PRODUCT_DOESNT_EXIST = "Product doesn't exist.";
